import { Select as AntSelect } from 'antd';
import { SelectProps as AntSelectProps, SelectValue as AntSelectValue } from 'antd/lib/select';

export type SelectProps<T> = {
  // TODO
};

const Select = <T extends AntSelectValue>(props: SelectProps<T> & AntSelectProps<T>) => {
  return <AntSelect {...props} className="select" />;
};

Select.defaultProps = {
  allowClear: undefined,
  autoClearSearchValue: true,
  placeholder: '선택하세요.',
  size: 'middle',
  dropdownMatchSelectWidth: true,
  disabled: false,
  loading: false,
};

export default Select;
